import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CmsService } from '@services/cms/cms.service';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly cmsService = inject(CmsService);

  constructor() {
    effect(() => {
      const brandData = this.cmsService.brandDataComponentCopy();
      if (!isPlatformBrowser(this.platformId) || brandData == null) {
        return;
      }

      this.setFavicon(brandData.images.favicon.desktopImage.url);
    });
  }

  private setFavicon(url: string): void {
    let link = this.document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'icon';
      this.document.head.appendChild(link);
    }
    link.href = url;
  }
}
